import { ProjectEditComponent } from './views/projects/project-edit/project-edit.component';
import { ProjectCreateComponent } from './views/projects/project-create/project-create.component';
import { ConsultantsReportComponent } from "./views/reports/consultants-report/consultants-report.component";
import { Routes } from "@angular/router";
import { LoginComponent } from "./views/login/login.component";

import { BillingLetterComponent } from "./views/billing-letter/billing-letter.component";
import { ApprovalsComponent } from "./views/approvals/approvals.component";
import { ConsultantsComponent } from "./views/consultants/consultants.component";

import { CompaniesComponent } from "./views/companies/companies.component";
import { ConsultantCreateComponent } from "./views/consultants/consultant-create/consultant-create.component";
import { CompanieCreateComponent } from "./views/companies/companie-create/companie-create.component";

import { CompanyGroupComponent } from "./views/companies/company-group/company-group.component";
import { ApprovalCreateComponent } from "./views/approvals/approvals-create/approvals-create.component";
import { ApprovalEditComponent } from "./views/approvals/approvals-edit/approvals-edit.component";
import { ConsultantEditComponent } from "./views/consultants/consultant-edit/consultant-edit.component";
import { BillingLetterCreateComponent } from './views/billing-letter/billing-letter-create/billing-letter-create.component';
import { CompanyMatchComponent } from './views/companies/company-match/company-match.component';
import { CompaniesEditComponent } from "./views/companies/companies-edit/companies-edit.component";
import { BillingLetterEditComponent } from './views/billing-letter/billing-letter-edit/billing-letter-edit.component';

import {BillingLettersReportComponent} from "./views/reports/billing-letters-report/billing-letters-report.component";
import {LogComponent} from "./views/log/log.component";
import {NotificationsComponent} from "./views/notifications/notifications.component";
import {EditMultiApprovalsComponent} from "./views/approvals/edit-multi-approvals/edit-multi-approvals.component";
import { ProjectsComponent } from "./views/projects/projects.component";
import { ArchiveComponent } from './views/archive/archive/archive.component';
import { ArchiveDetailsComponent } from './views/archive/archive/archive-details/archive-details.component';
import { AuthComponent } from './views/auth/auth.component';
import { RefundsReportComponent } from './views/refunds-report/refunds-report.component';
import { RefundDetailComponent } from './views/refunds-report/refund-detail/refund-detail.component';

import { CnaesComponent } from './views/cnaes/cnaes.component';
import { CnaeCreateComponent } from './views/cnaes/cnaes-create/cnaes-create.component';
import { CnaeEditComponent } from './views/cnaes/cnaes-edit/cnaes-edit.component';

import { PurchaseOrderComponent } from './views/purchase-order/purchase-order.component';
import { PurchaseOrderCreateComponent } from './views/purchase-order/purchase-order-create/purchase-order-create.component';
import { PurchaseOrderDetailComponent } from './views/purchase-order/purchase-order-detail/purchase-order-detail.component';
import { PurchaseOrderHierarchyComponent } from './views/purchase-order/purchase-order-hierarchy/purchase-order-hierarchy.component';

import { AuthGuard } from "./shared/AuthGuard";
import { InvoiceAttachComponent } from './views/invoice-attach/invoice-attach.component';

import { PublicConsultantEditComponent } from './views/consultants/public-consultant-edit/public-consultant-edit.component';
import { UsersComponent } from './views/users/users.component';
import { UsersCreateComponent } from './views/users/users-create/users-create.component';
import { UsersEditComponent } from './views/users/users-edit/users-edit.component';

import { HomeComponent } from './views/home/home.component';
import { DashboardComponent } from './views/dashboard/dashboard.component';
import { CompanyInventoryComponent } from './views/companies/company-inventory/companyInventory.component';
import { CompanyInventoryCreateComponent } from './views/companies/company-inventory/company-inventory-create/company-inventory.component-create'
import { CompanyInventoryEditComponent } from './views/companies/company-inventory/company-inventory-edit/company-inventory.component-edit'
import { ApprovalsUploadComponent } from "./views/approvals/approvals-upload/approvals-upload.component";
import { VendorInventoryComponent } from './views/companies/vendor-inventory/vendorInventory.component';
import { VendorInventoryCreateComponent } from './views/companies/vendor-inventory/vendor-inventory-create/vendor-inventory.component-create';
import { VendorInventoryEditComponent } from './views/companies/vendor-inventory/vendor-inventory-edit/vendor-inventory.component-edit';


export const AppRoutes: Routes = [
    {
        path:"",
        redirectTo: "/home",
        pathMatch: "full"
    },
    {
        path: "login",
        component: LoginComponent
    },
    {
        path: "home",
        component: HomeComponent,
        canActivate: [AuthGuard]
    },
    {
        path: "invoice-attach/:hash",
        component: InvoiceAttachComponent
    },
    {
        path: "log",
        component: LogComponent,
        canActivate: [AuthGuard],
        data: {
            method: "list"
        }
    },
    {
        path: "notifications",
        children: [
            {
                path:"user/:id",
                component: NotificationsComponent,
                canActivate: [AuthGuard],
                pathMatch:"full",
                data: {
                    method: "list"
                }
            }
        ]
    },
    {
        path: "dashboard",
        component: DashboardComponent,
        canActivate: [AuthGuard],
        data: {
            method: "list"
        }
    },
    {
        path: "billing-letter",
        children: [
            {
                path: "",
                component: BillingLetterComponent,
                canActivate: [AuthGuard],
                pathMatch: "full",
                data: {
                    method: "list"
                }
            },
            {
                path: "new",
                component: BillingLetterCreateComponent,
                canActivate: [AuthGuard],
                pathMatch: "full",
                data: {
                    method: "new",
                    blocked: true
                }
            },
            {
                path:"edit/:id",
                component:BillingLetterEditComponent,
                canActivate: [AuthGuard],
                pathMatch:"full",
                data: {
                    method: "edit"
                }
            }
        ]
    },
    {
        path: "accounting-block",
        loadChildren: './views/accounting-period-block/accounting-period-block.module#AccountingPeriodBlockModule',
    },
    {
        path: "approvals",
        children: [
            {
                path: "",
                component: ApprovalsComponent,
                canActivate: [AuthGuard],
                pathMatch: "full",
                data: {
                    method: "list"
                }
            },
            {
                path: "new",
                component: ApprovalCreateComponent,
                canActivate: [AuthGuard],
                pathMatch: "full",
                data: {
                    method: "new",
                    blocked: true
                }
            },
            {
                path: "approvals-edit/:id",
                component: ApprovalEditComponent,
                canActivate: [AuthGuard],
                pathMatch: "full",
                data: {
                    method: "edit"
                }
            },
            {
                path: "multi-approvals-edit",
                component: EditMultiApprovalsComponent,
                canActivate: [AuthGuard],
                pathMatch: "full",
            },
            {
                path: "approvals-upload",
                component: ApprovalsUploadComponent,
                canActivate: [AuthGuard],
                pathMatch: "full",
                data: {
                    method: "upload"
                }
            }
        ]
    },
    {
        path: "refunds",
        children: [
            {
                path: "",
                component: RefundsReportComponent,
                canActivate: [AuthGuard],
                pathMatch: "full",
                data: {
                    method: "list"
                }
            },
            {
                path: "edit/:id",
                component: RefundDetailComponent,
                canActivate: [AuthGuard],
                pathMatch: "full",
                data: {
                    method: "edit"
                }
            }
        ]
    },
    {
        path: "purchase-orders",
        children: [
            {
                path: "",
                component: PurchaseOrderComponent,
                canActivate: [AuthGuard],
                pathMatch: "full",
                data: {
                    method: "list"
                }
            },
            {
                path: "new",
                component: PurchaseOrderCreateComponent,
                canActivate: [AuthGuard],
                pathMatch: "full",
                data: {
                    method: "new",
                    blocked: true
                }
            },
            {
                path: "edit/:id",
                component: PurchaseOrderDetailComponent,
                canActivate: [AuthGuard],
                pathMatch: "full",
                data: {
                    method: "edit"
                }
            },
            {
                path: "hierarchy",
                component: PurchaseOrderHierarchyComponent,
                canActivate: [AuthGuard],
                pathMatch: "full",
                data: {
                    method: "hierarchy"
                }
            },
        ]
    },
    {
        path: "companies",
        children: [
            {
                path: "",
                component: CompaniesComponent,
                canActivate: [AuthGuard],
                pathMatch: "full",
                data: {
                    method: "list"
                }
            },
            {
                path: "new",
                component: CompanieCreateComponent,
                canActivate: [AuthGuard],
                pathMatch: "full",
                data: {
                    method: "new",
                    blocked: true
                }
            },
            {
                path: "group",
                component: CompanyGroupComponent,
                canActivate: [AuthGuard],
                pathMatch: "full",
                data: {
                    method: "group"
                }
            },
            {
                path: "company-match",
                component: CompanyMatchComponent,
                canActivate: [AuthGuard],
                pathMatch: "full",
                data: {
                    method: "match"
                }
            },
            {
                path: "companies-edit/:id",
                component: CompaniesEditComponent,
                canActivate: [AuthGuard],
                pathMatch: "full",
                data: {
                    method: "edit"
                }
            },
            {
                path: "company-inventory",
                component: CompanyInventoryComponent,
                canActivate: [AuthGuard],
                pathMatch: "full",
                data: {
                    method: "inventory-list"
                }
            },
            {
                path: "company-inventory/new",
                component: CompanyInventoryCreateComponent,
                canActivate: [AuthGuard],
                pathMatch: "full",
                data: {
                    method: "company-inventory-new",
                    blocked: true
                }
            },
            {
                path: "company-inventory/edit/:id",
                component: CompanyInventoryEditComponent,
                canActivate: [AuthGuard],
                pathMatch: "full",
                data: {
                    method: "company-inventory-edit"
                }
            },
            {
                path: "vendor-inventory",
                component: VendorInventoryComponent,
                canActivate: [AuthGuard],
                pathMatch: "full",
                data: {
                    method: "vendor-inventory-list"
                }
            },
            {
                path: "vendor-inventory/new",
                component: VendorInventoryCreateComponent,
                canActivate: [AuthGuard],
                pathMatch: "full",
                data: {
                    method: "vendor-inventory-new",
                    blocked: true
                }
            },
            {
                path: "vendor-inventory/edit/:id",
                component: VendorInventoryEditComponent,
                canActivate: [AuthGuard],
                pathMatch: "full",
                data: {
                    method: "vendor-inventory-edit"
                }
            },

        ]
    },
    {
        path: "consultants",
        children: [
            {
                path: "",
                component: ConsultantsComponent,
                canActivate: [AuthGuard],
                pathMatch: "full",
                data: {
                    method: "list"
                }
            },
            {
                path: "new",
                component: ConsultantCreateComponent,
                canActivate: [AuthGuard],
                pathMatch: "full",
                data: {
                    method: "new",
                    blocked: true
                }
            },
            {
                path: "consultant-edit/:id",
                component: ConsultantEditComponent,
                canActivate: [AuthGuard],
                pathMatch: "full",
                data: {
                    method: "edit"
                }
            },
            {
                path: "public-consultant-edit/:id",
                component: PublicConsultantEditComponent,
                canActivate: [AuthGuard],
                pathMatch: "full",
                data: {
                    method: "public"
                }
            },
            {
                path: "archives",
                component: ArchiveComponent,
                canActivate: [AuthGuard],
                pathMatch: "full",
                data: {
                    method: "archives"
                }
            },
            {
                path: "archives/details/:id",
                component: ArchiveDetailsComponent,
                canActivate: [AuthGuard],
                pathMatch: "full",
                data: {
                    guards: []
                }
            }
        ]
    },
    {
        path: "reports",
        children: [
            {
                path: "consultant",
                component: ConsultantsReportComponent,
                canActivate: [AuthGuard],
                pathMatch: "full",
                data: {
                    method: "consultant"
                }
            },
            {
                path: "billing-letters",
                component: BillingLettersReportComponent,
                pathMatch: "full",
                canActivate: [AuthGuard],
                data: {
                    method: "billing-letter"
                }
            }
        ]
    },
    {
        path: "projects",
        children: [
            {
                path: "",
                component: ProjectsComponent,
                canActivate: [AuthGuard],
                pathMatch: "full",
                data: {
                    method: "list"
                }
            },
            {
                path: "new",
                component: ProjectCreateComponent,
                canActivate: [AuthGuard],
                pathMatch: "full",
                data: {
                    method: "new",
                    blocked: true
                }
            },
            {
                path: "edit/:id",
                component: ProjectEditComponent,
                canActivate: [AuthGuard],
                pathMatch: "full",
                data: {
                    method: "edit"
                }
            },
        ]
    },
    {
        path: "cnaes",
        children: [
            {
                path: "",
                component: CnaesComponent,
                canActivate: [AuthGuard],
                pathMatch: "full",
                data: {
                    method: "list"
                }
            },
            {
                path: "new",
                component: CnaeCreateComponent,
                canActivate: [AuthGuard],
                pathMatch: "full",
                data: {
                    method: "new",
                    blocked: true
                }
            },
            {
                path: "edit/:id",
                component: CnaeEditComponent,
                canActivate: [AuthGuard],
                pathMatch: "full",
                data: {
                    method: "edit"
                }
            },
        ]
    },
    {
        path: "users",
        children: [
            {
                path: "",
                component: UsersComponent,
                canActivate: [AuthGuard],
                pathMatch: "full",
                data: {
                    method: "list"
                }
            },
            {
                path: "new",
                component: UsersCreateComponent,
                canActivate: [AuthGuard],
                pathMatch: "full",
                data: {
                    method: "new",
                    blocked: true
                }
            },
            {
                path: "edit/:id",
                component: UsersEditComponent,
                canActivate: [AuthGuard],
                pathMatch: "full",
                data: {
                    method: "edit"
                }
            },
        ]
    },
    // {
    //     path: "legal-certificates",
    //     children: [
    //         {
    //             path: "",
    //             component: LegalCertificateComponent,
    //             canActivate: [AuthGuard],
    //             pathMatch: "full",
    //             data: {
    //                 method: "list"
    //             }
    //         },
    //         {
    //             path: "new",
    //             component: LegalCertificateCreateComponent,
    //             canActivate: [AuthGuard],
    //             pathMatch: "full",
    //             data: {
    //                 method: "new"
    //             }
    //         },
    //         {
    //             path: "edit/:id",
    //             component: LegalCertificateEditComponent,
    //             canActivate: [AuthGuard],
    //             pathMatch: "full",
    //             data: {
    //                 method: "edit"
    //             }
    //         },
    //     ]
    // },
    {
        path: 'auth',
        component: AuthComponent
    },
    // {
    //     path: 'self-fill/:hash',
    //     loadChildren: './views/self-fill/self-fill.module#SelfFillModule'
    // }
];




// WEBPACK FOOTER //
// ./src/app/app.routing.ts